import {
  CepLookupResultSchema,
  type CepLookupResult,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

/**
 * Endereços REST surface — proxy to BrasilAPI/ViaCEP for CEP lookups.
 */
export class EnderecosEndpoints {
  constructor(private readonly client: ApiClient) {}

  lookupCep(cep: string): Promise<CepLookupResult> {
    const clean = cep.replace(/\D/g, '');
    return this.client.get<CepLookupResult>(`/enderecos/cep/${clean}`, {
      responseSchema: CepLookupResultSchema,
    });
  }
}
